import PropTypes from 'prop-types';
import React from 'react';

import * as consts from '../../../constants';
import commonFunctions from '../../../commonFunctions';

import AirBnbDateTimePicker from '../../common/airBnbDatepicker/AirBnbDateTimePicker';
import SelectInput from '../../common/SelectInput';
import TextInput from '../../common/TextInput';

const UserSection = ({ authenticationState, isAgent, title, userData, onChange, showAllProps = false }) => {
    const roles = commonFunctions.allRoles();
    roles.unshift({ value: -1, text: '---' });

    const showCompanyForMaster = userData != null && userData.role === consts.AUTHENTICATION.USER_ROLE.NetworkMaster;

    return (
        <div className="panel panel-default x-panel">
            <div className="panel-heading">{title}</div>
            <div className="panel-body">
                <TextInput
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && !isAgent ? 'disabled' : ''}
                    name="userData_firstName"
                    label="Nome"
                    required={true}
                    value={userData.firstName}
                    onChange={onChange} />
                <TextInput
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && !isAgent ? 'disabled' : ''}
                    name="userData_lastName"
                    label="Cognome"
                    required={true}
                    value={userData.lastName}
                    onChange={onChange} />
                <TextInput
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && !isAgent ? 'disabled' : ''}
                    name="userData_username"
                    label="Username"
                    required={true}
                    value={userData.username}
                    onChange={onChange} />
                <TextInput
                    autocomplete='off'
                    name="userData_password"
                    label="Password"
                    value={userData.password}
                    type='password'
                    onChange={onChange} />
                {isAgent ? '' : <TextInput
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && !isAgent ? 'disabled' : ''}
                    name="userData_ateco"
                    label="Ateco"
                    required={false}
                    value={userData.ateco}
                    onChange={onChange} />}
                {isAgent ? '' : <TextInput
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && !isAgent ? 'disabled' : ''}
                    name="userData_sae"
                    label="SAE"
                    required={false}
                    value={userData.sae}
                    onChange={onChange} />}
                {showCompanyForMaster ? <TextInput
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb ? 'disabled' : ''}
                    name="userData_companyForMaster"
                    label="Azienda di Riferimento"
                    value={userData.companyForMaster}
                    onChange={onChange} /> : ''}
                {showAllProps ? <SelectInput
                    label='Ruolo'
                    name='userData_role'
                    onChange={onChange}
                    options={roles}
                    value={userData.role} /> : ''}
                <TextInput
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && !isAgent ? 'disabled' : ''}
                    name="userData_taxCode"
                    label="C.F."
                    isCF={true}
                    required={true}
                    value={userData.taxCode}
                    onChange={onChange} />
                <AirBnbDateTimePicker
                    disabled={authenticationState.roleId > consts.AUTHENTICATION.USER_ROLE.Seb && !isAgent}
                    name='userData_birthDate'
                    label="Data Nascita"
                    required={true}
                    value={userData.birthDate}
                    onChange={onChange} />
                <h3>Contatti</h3>
                <TextInput
                    name="userData_emailAddress"
                    label="E-mail"
                    type='email'
                    required={true}
                    errorMessage='Email non corretta'
                    value={userData.emailAddress}
                    onChange={onChange} />
                <TextInput
                    name="userData_emailAddress2"
                    label="E-mail secondaria"
                    type='email'
                    required={false}
                    errorMessage='Email non corretta'
                    value={userData.emailAddress2}
                    onChange={onChange} />
                <TextInput
                    name="userData_workPhone"
                    label="Telefono"
                    required={true}
                    value={userData.workPhone}
                    onChange={onChange} />
                <TextInput
                    name="userData_workPhone2"
                    label="Telefono secondario"
                    required={false}
                    value={userData.workPhone2}
                    onChange={onChange} />
            </div>
        </div>
    );
};

UserSection.propTypes = {
    title: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    isAgent: PropTypes.bool.isRequired,
    authenticationState: PropTypes.object.isRequired
};

export default UserSection;
